import React, { useEffect, useState } from 'react'
import { PngImages, SvgImages } from '../../../Utils/LocalImages';
import Image from '../../../Components/Reusable/Image';
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import RoutesPath from '../../../Utils/RoutesPath';
import ButtonWithIcon from '../../../Components/Reusable/ButtonWithIcon';
import jsPDF from "jspdf";
import "jspdf-autotable";
import parse from "html-react-parser";
import BharatSatService from '../../../Services/BharatSatService';
import { handleApiErrors } from '../../../Utils/Utils';
import { FaCheck } from "react-icons/fa6";

const BharatSatQuestionsDetails = () => {
    const [data, setData] = useState({ subjects: [], subjectQuestions: [] });
    const [allQuestions, setAllQuestions] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [activeTab, setActiveTab] = useState('');
    const {bharatSatExamId} = useParams();
    const [selectedSubjectId, setSelectedSubjectId] = useState(null);



    const bharatSatQuestionsDetails = async () => {
        try {
            const response = await BharatSatService.bharatSatQuestionsDetails(bharatSatExamId);
            if (response.message === 'Success') {
                setData(response.data);
                // Set default subject for initial display if available
                if (response.data.subjects.length > 0 && !selectedSubjectId) {
                    const defaultSubject = response.data.subjects[0];
                    setSelectedSubjectId(defaultSubject.subjectId);
                    setActiveTab(defaultSubject.subjectName);
                    // Filter the questions for the default subject
                    const subjectQuestions = response.data.subjectQuestions.find(
                        (subject) => subject.subjectId === defaultSubject.subjectId
                    );
                    setAllQuestions(subjectQuestions ? subjectQuestions.questions : []);
                }
            } else {
                console.error('Error in API response:', response.message);
            }
        } catch (error) {
            console.error('Error fetching Bharat SAT data:', error);
        }
    };
    const handleSubjectChange = (subjectId, subjectName) => {
        setSelectedSubjectId(subjectId);
        setActiveTab(subjectName);

        // Filter questions based on selected subjectId
        const subjectQuestions = data.subjectQuestions.find(
            (subject) => subject.subjectId === subjectId
        );
        setAllQuestions(subjectQuestions ? subjectQuestions.questions : []);
    };

    const customParser = (node) => {
        if (node.name === "oembed") {
            const url = node.attribs.url;
            let videoId;
            // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
            if (url.includes("youtube.com")) {
                videoId = new URL(url).searchParams.get("v");  // Extract the video ID from the "v" parameter
            } else if (url.includes("youtu.be")) {
                videoId = url.split("/").pop().split("?")[0];  // Extract the ID after the last "/"
            }
            if (videoId) {
                return (
                    <iframe
                        width="560"
                        height="315"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="YouTube video"
                    />
                );
            } else {
                return <p className='text-danger'>Invalid YouTube URL</p>;
            }
        }
    };
    const cleanQuestionText = (text) => {
        return text.replace(/&nbsp;/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };


    const generatePDF = () => {
        if (allQuestions.length === 0) {
            alert("No questions to export");
            return;
        }

        const doc = new jsPDF();
        const tableBody = [];

        // Add Title
        doc.setFontSize(16);
        doc.text("Bharat SAT Question Paper", 105, 10, { align: "center" });

        // Loop through all questions to create rows
        allQuestions.forEach((question, qIndex) => {
            const questionText = question.heading || `Question ${qIndex + 1}`;
            tableBody.push([`Q${qIndex + 1}`, questionText, question.marks || ""]);

            // Add subquestions if available
            question.subQuestions?.forEach((subQ, subIndex) => {
                const subQuestionText = subQ.question || `Sub-question ${subIndex + 1}`;
                tableBody.push([`Q${qIndex + 1}.${subIndex + 1}`, subQuestionText, subQ.marks || ""]);

                // Add subquestion options
                subQ.options?.forEach((option, optIndex) => {
                    const optionText = cleanQuestionText(option);
                    const optionLabel = getAlphabetLabel(optIndex);
                    tableBody.push([`Option ${optionLabel}`, optionText, ""]);
                });
            });
        });

        // Generate the table
        doc.autoTable({
            head: [["Index", "Question", "Marks"]],
            body: tableBody,
            startY: 20,
        });

        // Save the PDF
        doc.save("Bharat_SAT_Questions.pdf");
    };



    useEffect(() => {
        bharatSatQuestionsDetails(bharatSatExamId);
    }, [bharatSatExamId]);

    const getAlphabetLabel = (index) => {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        return letters[index] || "";
    };
    return (
        <div>
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <h1 className="black fs-18 fw-600 mb-0">BHARAT SAT</h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0">Bharat SAT</h4>
                </div>
            </div>
            <div className="table_container">
                <div className='d-flex justify-content-between'>
                    <h1 className="black fs-18 fw-600 mb-0">Question Paper</h1>
                    <div className="">
                        <ButtonWithIcon
                            text={"Export"}
                            icon={PngImages.pdfpic}
                            onClick={generatePDF}
                        />
                    </div>
                </div>
                <ul className="small-medium-text overflow-auto fw-600 list-group list-group-horizontal gap-1 mb-3 mt-4 text-white">
                    {data.subjects.map(subject => (
                        <li
                            key={subject.subjectId}
                            className={`list-group-item border-0 ${activeTab === subject.subjectName ? 'active' : ''}`}
                            onClick={() => handleSubjectChange(subject.subjectId, subject.subjectName)}
                            style={{ cursor: 'pointer', borderRadius: "6px", backgroundColor: activeTab === subject.subjectName ? '#14489F' : 'transparent' }}
                        >
                            {subject.subjectName}
                        </li>
                    ))}
                </ul>
                <section className='small-medium-text fw-600 my-4'>
                    {allQuestions.length > 0 ? (

                        <>
                            {allQuestions.map((q, index) => {
                                // Get the starting cumulative count for the selected subject
                                // const startIndex = cumulativeCounts[selectedSubjectId] || 0;
                                // const currentQuestionIndex = startIndex + index + 1;  // Continuous question numbering
                                return (
                                    <div key={index} className='my-4 border-question '>
                                        <div className="small-medium-text fw-600 mb-3">
                                            {q.heading} <span style={{ color: q.markColor }}>{q.marks}</span>
                                        </div>

                                        <div className="small-medium-text   fw-600 mb-3 d-flex justify-content-start text-center gap-1">
                                            Question {index + 1}
                                            <div>

                                            </div>
                                        </div>


                                        {q.typeOfQuestion === 'Comprehensive' || q.typeOfQuestion === 'Poem' ? (
                                            <div>
                                                <div className='fs-14 fw-600 mb-2 pt-2 black border-question-top'>Read Carefully</div>
                                                {q?.typeOfQuestion === 'Comprehensive' || q?.typeOfQuestion === 'Poem' ? (


                                                    <div className="fw-400  blog-data-html" style={{ contain: "content", width: '100%' }}>
                                                        {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}

                                                    </div>

                                                ) : (
                                                    null

                                                )}

                                                {q.subQuestions.map((subQ, subIndex) => (
                                                    <div key={subIndex} className='my-4'>

                                                        <div className=" d-flex justify-content-between">
                                                            <div className="d-flex gap-2 align-items-center">
                                                                <div className="small-medium-text fw-600 text-dark d-flex  align-items-center gap-2">

                                                                    <div style={{ marginBottom: '6px' }}>{subIndex + 1}.</div>
                                                                    {q?.typeOfQuestion === 'Poem' || 'Comprehensive' ? (

                                                                        <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                            {cleanQuestionText(subQ?.question) && parse(cleanQuestionText(subQ.question), { replace: customParser })}
                                                                        </div>

                                                                    ) : (
                                                                        null

                                                                    )}

                                                                </div>

                                                            </div>
                                                            {/* <div>
                                            {subQ.selectedOption == null ? (
                                                <span style={{ color: "#FF0000" }}>Not Answered</span>
                                            ) : (
                                                null
                                            )}
                                        </div> */}
                                                        </div>
                                                        <ol className="list-group mt-2 ">
                                                            {subQ.options.map((option, optIndex) => {
                                                                const isUserSelected = subQ.selectedOption === optIndex;
                                                                const isCorrectOption = subQ.correctOption === optIndex;

                                                                return (
                                                                    <li
                                                                        key={optIndex}
                                                                        className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                                                        style={{
                                                                            color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                                                        }}
                                                                    >
                                                                        <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                                                            <div className="checkmarks"
                                                                                style={{
                                                                                    border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                                                                    backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                                                                    marginBottom: "16px"
                                                                                }}
                                                                            >
                                                                                {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}                                                                  </div>
                                                                            <label
                                                                                className="form-check-label small-medium-text fw-400 px-2  "
                                                                                htmlFor={`Comprehensive-option-${index}-${subIndex}`}
                                                                            >
                                                                                <div className="d-flex gap-2">
                                                                                    <span>{getAlphabetLabel(optIndex)}. </span> <span>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</span>
                                                                                    <div className="text-end">
                                                                                        {isCorrectOption && !isUserSelected && (
                                                                                            <span className="fs-14 ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                                                                        )}
                                                                                        {/* {isUserSelected && !isCorrectOption && (
                                                                        <span className="text-danger small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Incorrect Answer</span>
                                                                    )}
                                                                    {isUserSelected && isCorrectOption && (
                                                                        <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Your Answer</span>
                                                                    )} */}
                                                                                    </div>
                                                                                </div>

                                                                            </label>
                                                                        </div>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ol>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div>
                                                <div className="d-flex justify-content-between">
                                                    {q?.typeOfQuestion === 'General' ? (

                                                        <div className=" blog-data-html " style={{ contain: "content", width: '100%' }}>

                                                            {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}

                                                        </div>

                                                    ) : (
                                                        null
                                                    )}

                                                    {/* <div>
                                    {q.selectedOption == null ? (
                                        <span style={{ color: "#FF0000" }}>Not Answered</span>
                                    ) : (
                                        null
                                    )}
                                </div> */}
                                                </div>

                                                <ol className="list-group my-2">
                                                    {q.options.map((option, optIndex) => {
                                                        const isUserSelected = q.selectedOption === optIndex;
                                                        const isCorrectOption = q.correctOption === optIndex;

                                                        return (
                                                            <li
                                                                key={optIndex}
                                                                className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                                                style={{
                                                                    color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                                                }}
                                                            >
                                                                <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                                                    <div className="checkmarks"
                                                                        style={{
                                                                            border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                                                            backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                                                            marginBottom: "16px"
                                                                        }}
                                                                    >
                                                                        {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}                                                                  </div>
                                                                    <label
                                                                        className="form-check-label small-medium-text fw-500 px-2"
                                                                        htmlFor={`General-option-${index}-${optIndex}`}
                                                                    >
                                                                        <div className="d-flex gap-2 fw-400">
                                                                            <span >{getAlphabetLabel(optIndex)}. </span> <span><p>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</p></span>
                                                                            <div>
                                                                                {isCorrectOption && !isUserSelected && (
                                                                                    <span className="fs-14 ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                                                                )}
                                                                                {/* {isUserSelected && !isCorrectOption && (
                                                                <span className="text-danger small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Incorrect Answer</span>
                                                            )}
                                                            {isUserSelected && isCorrectOption && (
                                                                <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Your Answer</span>
                                                            )} */}
                                                                            </div>
                                                                        </div>
                                                                    </label>
                                                                </div>
                                                            </li>
                                                        );
                                                    })}
                                                </ol>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}</>
                    ) : (
                        <div className="d-flex flex-column align-items-center justify-content-center my-3 h-100">
                            <Image
                                src={SvgImages.noTopics}
                                style={{ height: 250 }}
                            />
                            <h1 className="subText fs-20 fw-600 my-3 black">
                                No Questions Found
                            </h1>
                        </div>
                    )}
                </section>


                {/* <div className="d-flex justify-content-start">
                    <div
                        className="blue cursor-pointer mt-3 fw-500 fs-14"
                        onClick={() => {
                            navigate(RoutesPath.registrationPageListing);
                        }}
                    >
                        {" "}
                        <Image src={SvgImages.left_arrow} className="blue mx-3" />
                        Back
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default BharatSatQuestionsDetails




